export default {
  quoteText: "To be, or not to be, that is the question...",
  quoteBy: "William Shakespeare"
};
